import { WrapColumns } from 'common/Prose/Toolbar/components/WrapColumns/WrapColumns'
import { type EditorView } from 'prosemirror-view'
import queryClient from 'queryClient'
import { useRef } from 'react'
import { QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import store from 'redux/store'
import { useDetectKeyDown, useDetectOutsideClick } from 'utils/hookUtils'

export const fixedWidthPromptHeight = 208

export const ColumnsPrompt = ({ close, view }: { close: () => void; view: EditorView }) => {
  const ref = useRef(null)
  useDetectOutsideClick(ref, close)
  useDetectKeyDown(
    ['Escape', 'Enter'],
    (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      close()
    },
    undefined,
    true,
  )

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <div onMouseLeave={close} ref={ref}>
          <WrapColumns handleArrowKeys={true} view={view} />
        </div>
      </Provider>
    </QueryClientProvider>
  )
}
